import { executeApiRequest } from './../middleware/api'
import { API } from './endpoints'

const get = (prop: string) => executeApiRequest({ url: API.PROPERTY_FRIENDS.BASE, params: { prop } })

export default {
  get,
}
